module.exports = __webpack_public_path__ + "media/the_place_we_used_to_called_home.c16eafbd.wav";